import Head from 'next/head';
import React from 'react';
import Authlayout from '../../components/widgets/auth-layout';
import NewPasswordWidget from '../../components/widgets/password-reset/new-password';

const NewPassword = () => {
  return (
    <>
      <Head>
        <title>New Password</title>
        <meta
          name="description"
          content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
        />
        <link rel="icon" href="/favicon.png" />
      </Head>
      <Authlayout>
        <NewPasswordWidget />
      </Authlayout>
    </>
  );
};

export default NewPassword;
